export enum RoutePaths {
  // 登录
  Login = '/login',
  // 注册
  SignUp = '/signup',

  Home = '/',

  App = '/app',

  Collaboration = '/collaboration'
}